// Settings.tsx

import React, { useState } from 'react';
import Header from './Header.tsx';
import Sidebar from './Sidebar.tsx';
import user_plus from '../Images/user-plus.svg';
import styles from './Settings.module.css';
import { /*NavLink,*/ Outlet, useLocation } from 'react-router-dom';
import Modal from './Modal.tsx';
import { FaRegBuilding } from 'react-icons/fa';
import { sidebarOpenForViewport } from '../context/SidebarProvider.tsx';

function Settings() {
  const [showSidebar, setShowSidebar] = useState(sidebarOpenForViewport);
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [openClient, setOpenClient] = useState(false);

  // Handlers to open modals
  const handleModalOpen = () => {
    setOpen(true);
  };

  const handleModalOpenClient = () => {
    setOpenClient(true);
  };

  return (
    <section className={styles.section}>
      <div className={styles.profile}>
        <Header title="Settings" setShowSidebar={setShowSidebar} showSidebar={showSidebar} />

        <div className={styles.container}>
          <div
            className={`${styles.sidebarStyle} app-sidebar-rail`}
            style={{
              width: showSidebar ? '224px' : '56px',
              transition: 'width 0.3s',
            }}
          >
            <Sidebar />
          </div>

          <div className={styles.mainContentStyle}>
            <div className={styles.topNav}>
              {/* <nav className={styles.nav}>
                <ul>
                  <li>
                    <NavLink
                      to="users"
                      className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}
                    >
                      Users Management
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="clients"
                      className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}
                    >
                      Organizations Management
                    </NavLink>
                  </li>
                </ul>
              </nav> */}

              {pathname.includes('/users') ? (
                <button className={styles.add_user} onClick={handleModalOpen} aria-label="Add User">
                  <img src={user_plus} alt="Add User Icon" className={styles.user_img} />
                  Add User
                </button>
              ) : (
                <button
                  className={styles.add_user}
                  onClick={handleModalOpenClient}
                  aria-label="Add Organization"
                >
                  <FaRegBuilding style={{ marginRight: '8px' }} />
                  Add Organization
                </button>
              )}
            </div>

            <Outlet />

            {open && <Modal open={open} setOpen={setOpen} />}
            {openClient && (
              <Modal
                openClient={openClient}
                setOpenClient={setOpenClient}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Settings;
